import React, { useState } from 'react';
import { volunteerService } from '../services';
import PageBreadcrumb from '../components/PageBreadcrumb';

const initialForm = {
    name: '',
    email: '',
    phone: '',
    city: '',
    skills: '',
    availability: '',
    message: '',
};

const Volunteer = () => {
    const [formData, setFormData] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        try {
            await volunteerService.submit(formData);
            setStatus({ type: 'success', message: 'Your volunteer form has been submitted successfully.' });
            setFormData(initialForm);
        } catch (error) {
            setStatus({ type: 'error', message: error.response?.data?.message || 'Unable to submit form right now.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white">
            <PageBreadcrumb
                title="Volunteer With YAP"
                description="Share your skills and time to empower youth and strengthen communities."
                items={[{ label: 'Volunteer' }]}
            />

            <section className="mx-auto max-w-6xl px-4 py-14">
                <div className="grid gap-8 lg:grid-cols-2">
                    <div className="rounded-2xl border border-emerald-100 bg-emerald-50 p-8">
                        <h2 className="text-2xl font-bold text-emerald-900">Why Volunteer?</h2>
                        <ul className="mt-5 space-y-3 text-emerald-800">
                            <li>Mentor students in career and digital skills.</li>
                            <li>Support field activities and workshops.</li>
                            <li>Contribute to outreach, media, and logistics.</li>
                            <li>Build impact and leadership experience.</li>
                        </ul>
                        <div className="mt-8 rounded-xl bg-white p-5 text-slate-700">
                            <p className="font-semibold">All submissions appear in CMS at:</p>
                            <p className="mt-1 text-sm text-slate-600">Admin -> Volunteers</p>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
                        <h2 className="text-2xl font-bold text-slate-900">Volunteer Form</h2>
                        {status.message && (
                            <div className={`mt-4 rounded-lg p-3 text-sm ${status.type === 'success' ? 'bg-emerald-100 text-emerald-800' : 'bg-red-100 text-red-700'}`}>
                                {status.message}
                            </div>
                        )}
                        <div className="mt-6 grid gap-4 sm:grid-cols-2">
                            <input name="name" value={formData.name} onChange={handleChange} required placeholder="Full Name" className="rounded-lg border border-gray-300 px-4 py-2" />
                            <input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="Email" className="rounded-lg border border-gray-300 px-4 py-2" />
                            <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" className="rounded-lg border border-gray-300 px-4 py-2" />
                            <input name="city" value={formData.city} onChange={handleChange} placeholder="City" className="rounded-lg border border-gray-300 px-4 py-2" />
                            <input name="skills" value={formData.skills} onChange={handleChange} placeholder="Skills (e.g. teaching, design)" className="rounded-lg border border-gray-300 px-4 py-2 sm:col-span-2" />
                            <select name="availability" value={formData.availability} onChange={handleChange} className="rounded-lg border border-gray-300 px-4 py-2 sm:col-span-2">
                                <option value="">Availability</option>
                                <option value="weekdays">Weekdays</option>
                                <option value="weekends">Weekends</option>
                                <option value="flexible">Flexible</option>
                            </select>
                            <textarea name="message" value={formData.message} onChange={handleChange} rows="4" placeholder="Tell us how you want to contribute" className="rounded-lg border border-gray-300 px-4 py-2 sm:col-span-2" />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="mt-5 w-full rounded-lg bg-emerald-600 px-5 py-3 font-semibold text-white hover:bg-emerald-700 disabled:opacity-50"
                        >
                            {loading ? 'Submitting...' : 'Submit Volunteer Form'}
                        </button>
                    </form>
                </div>
            </section>
        </div>
    );
};

export default Volunteer;
